import styled from "@emotion/styled";
import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Loader, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { useTicketsToImport } from "hooks/useTicketsToImport";
import { IntegrationsActions, selectLiveChatSelectiveImportDiff } from "store/entities/integrations";

import { FullImportItem } from "./FullImportItem";
import { SelectiveImportItems } from "./SelectiveImportItems";

export const LiveChatDataImport: FC = () => {
  const dispatch = useDispatch();
  const importDiff = useSelector(selectLiveChatSelectiveImportDiff);
  const { ticketsToImport, isLoading: checkingTicketsToImport } = useTicketsToImport();
  const hasAgentsOrGroupsToImport = importDiff && (importDiff?.agents?.create > 0 || importDiff?.groups?.create > 0);
  const hasCannedResponsesToImport = importDiff && importDiff?.cannedResponses?.create > 0;
  const hasTagsToImport = importDiff && importDiff?.tags?.create > 0;
  const shouldDisplayImportPriorityInfo = hasAgentsOrGroupsToImport && (hasCannedResponsesToImport || hasTagsToImport);
  const loading = !ticketsToImport || checkingTicketsToImport;

  useEffect(() => {
    dispatch(IntegrationsActions.fetchLiveChatImportDiff());
    dispatch(IntegrationsActions.fetchLiveChatSelectiveImport());
  }, []);

  if (loading) {
    return (
      <Flex height="320px" alignContent="center" justifyContent="center">
        <Loader size="large" />
      </Flex>
    );
  }

  return (
    <Flex column maxWidth="800px" gap="12px">
      <FullImportItem />
      <SelectiveImportItems />
      {shouldDisplayImportPriorityInfo && (
        <ImportPriorityInfo>
          <b>Tip:</b> To keep your LiveChat data consistent in HelpDesk, <b>first import agents and groups</b> from the
          list above.
        </ImportPriorityInfo>
      )}
    </Flex>
  );
};

const ImportPriorityInfo = styled(Text)`
  margin-top: 0;
`;
